<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue'
import { TabsList, type TabsListProps } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<TabsListProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <TabsList
    v-bind="delegatedProps"
    :class="cn(
      'items-center justify-center',
      props.class,
    )"
  >
    <slot />
  </TabsList>
</template>

<style scoped lang="scss">
[data-orientation="vertical"] {
  display: grid;
  row-gap: 5px;
  grid-template-columns: 1fr;
}
</style>